import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';

import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { DateTime } from 'ionic-angular';

@Injectable()
export class ChecklistProvider {

  apiRoot: string = 'http://192.99.185.73:8070';

  constructor(public http: HttpClient) {
    console.log('Hello ChecklistProvider Provider');
  }

  getChecklist(){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
               .get(this.apiRoot + '/CheckListComparativo/Listar', { headers: header })
               .do(data => JSON.stringify(data))
               .catch(this.handleError);

  }

  getChecklistFiltrados(emailResponsavel: string,
                        emailSolicitante: string,
                        analisado: boolean,
                        dkPai: string,
                        dataInicial: DateTime,
                        dataFinal: DateTime,
                        limite: number){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
               .get(this.apiRoot + '/CheckListComparativo/Listar?parametros.emailResponsavel=' + emailResponsavel +'&parametros.emailSolicitante=' + emailSolicitante + '&parametros.analisado='+ analisado +'&parametros.dkPai=' + dkPai +'&parametros.dataSolicitacaoInicial='+ dataInicial +'&parametros.dataSolicitacaoFinal=' + dataFinal + '&parametros.limite=' + limite, { headers: header })
               .do(data => JSON.stringify(data))
               .catch(this.handleError);

  }

  getChecklistRecuperar(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
               .get(this.apiRoot + '/CheckListComparativo/RecuperarCheckList/' + Codigo, { headers: header })
               .do(data => data)
               .catch(this.handleError);

  }

  postCheckList(MLBConnect: string, MLBConcorrente: string, SKU: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

                let Email = localStorage.getItem('userLogin');

    return this.http
               .post(this.apiRoot + '/CheckListComparativo/NovoCheckList?mlbConnect=' + MLBConnect + '&mlbConcorrente=' + MLBConcorrente + '&dkPai=' + SKU + '&email=' + JSON.parse(Email).user_mail, Array.from(MLBConnect), { headers: header })
               .do(data => JSON.stringify(data))
               .catch(this.handleError);

  }

  postSalvarCustoIdeal(id: string, custoIdeal: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

                let Email = localStorage.getItem('userLogin');

    return this.http
               .post(this.apiRoot + '/CheckListComparativo/SalvarCustoIdeal/' + id + '?custoIdeal=' + custoIdeal + '&email=' + JSON.parse(Email).user_mail, Array.from(id), { headers: header })
               .do(data => JSON.stringify(data))
               .catch(this.handleError);

  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};
    if (error.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;
        console.log(error.error);

    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = { status: error.status, message: error.error.Message };
        console.log(error.error);

        if(error.status == 401){

          // this.nav.setRoot('LoginPage');
          // localStorage.clear();

        }

    }

    return Observable.throw(errorMessage);

  }

}



// WEBPACK FOOTER //
// ./src/providers/checklist/checklist.ts